export class MapMarker {
  title: string;
  body: string;
  customIconUrl: string;
  latitude: number;
  longitude: number;
  useCustomInfoWindow: boolean = false;
  infoWindowMaxWidth: number;
  locationKey?: string;
  _$visited?: any;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/MapMarker.ts